export const rateOrder = {
  'rate-order.title': 'Rate your order',
  'rate-order.subtitle.full':
    '{products} from {restaurant} on {wantedTime, date, medium} at {wantedTime, time, short}',
  'rate-order.subtitle.no-products':
    'From {restaurant} on {wantedTime, date, medium} at {wantedTime, time, short}',
  'rate-order.subtitle.no-restaurant':
    '{products} on {wantedTime, date, medium} at {wantedTime, time, short}',
  'rate-order.subtitle.no-time': '{products} from {restaurant}',
  'rate-order.subtitle.only-products': '{products}',
  'rate-order.subtitle.only-restaurant': 'From {restaurant}',
  'rate-order.subtitle.only-time':
    'On {wantedTime, date, medium} at {wantedTime, time, short}',
  'rate-order.hint': 'Choose all that apply',
  'rate-order.stars.title.1': 'Awful',
  'rate-order.stars.title.2': 'Bad',
  'rate-order.stars.title.3': 'Disappointing',
  'rate-order.stars.title.4': 'Pretty good, but...',
  'rate-order.stars.title.5': 'Perfection',
  'rate-order.call-to-action': 'Submit',
  'rate-order.response.success':
    "Thank you! Your feedback means a lot. We're always hungry to improve your experience.",
  'rate-order.response.failure':
    "Sorry we couldn't submit your feedback. Please try again.",
};
